import React from 'react'
import Banner from './Banner'
import BannerFact from './BannerFact'
import Feature from './Feature'
// import HomeAbout from './HomeAbout'
import HomeCalucuator from './HomeCalucuator'
import HomeLoanPage from './HomeLoanPage'
import HomeAboutUsSection from './HomeAboutUsSection'
import Coverage from './Coverage'
import GetinTouch from './GetinTouch'
import BarGraph from '../BarGraph'

export default function Home() {
  return (
    <main>
        <Banner/>
        <BannerFact/>
        <Feature/>
        {/* <HomeAbout/> */}
        <HomeCalucuator/>
        {/* <HomeLoanPage/> */}
        <br />
        <HomeAboutUsSection/>
        {/* <Coverage/> */}
        <GetinTouch/>
        {/* <BarGraph/> */}
    </main>

  )
}
